import * as Types from './types'

export const asFormFields = (lp: Types.LeadPost): Types.FormFields => {
  return {
    category_type_id: lp.category_type_id,
    description: lp.description,
    end_date: lp.end_datetime,
    feature_type: lp.feature_type,
    id: lp.id ? lp.id.toString() : null,
    image_url: lp.image_url,
    rank: lp.rank,
    site_name: lp.site_name,
    start_date: lp.start_datetime,
    title: lp.title,
    url: lp.url,
  }
}



// WEBPACK FOOTER //
// ./src/pages/lead-posts/utils.ts